import { useContext } from "react";
import {
  SignTypeContext,
  SignTypeContextProps,
} from "../../../context/SignTypeContext";
import Building from "../../../svg/Building";
import Calendar from "../../../svg/Calendar";
import IdentifyCard from "../../../svg/IdentifyCard";
import RubricIcon from "../../../svg/Rubric";
import SelectIcon from "../../../svg/SelectIcon";
import SignatureIcon from "../../../svg/SignatureIcon";
import TextIcon from "../../../svg/TextIcon";
import { Label, Wrapper } from "./styled";

interface RadioProps {
  id: string;
  name: string;
  value: string;
  label: string;
  setOpenModal?: any;
}

const Radio: React.FC<RadioProps> = ({ id, name, value, label, setOpenModal }) => {
  const { selectedOption, setSelectedOption } =
    useContext<SignTypeContextProps>(SignTypeContext);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    setSelectedOption(event.target.value);
  };
  const handleWrapperClick = () => {
    setSelectedOption(value === selectedOption ? "" : value);
    if (id === "select" ) {
      setOpenModal(true);
    }
  };
  return (
    <Wrapper
      id={id}
      checked={selectedOption === value}
      onClick={handleWrapperClick}
    >
      {id === "signature" && <SignatureIcon />}
      {id === "initial" && <RubricIcon />}
      {id === "text" && <TextIcon color="#2c2c2c" />}
      {id === "cpf" && <IdentifyCard />}
      {id === "cnpj" && <Building />}
      {id === "date" && <Calendar />}
      {id === "select" && <SelectIcon/>}
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={selectedOption === value}
        onChange={handleChange}
      />
      <Label htmlFor={id}>{label}</Label>
    </Wrapper>
  );
};

export default Radio;
